module.exports = __webpack_public_path__ + "static/media/ig5.21356224.jpg";